import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/utils/response.js";
import "./assets/styles/reset.css"; //重置样式
import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";

Vue.use(ViewUI);
import VideoPlayer from "vue-video-player";
import "vue-video-player/src/custom-theme.css";
import "video.js/dist/video-js.css";
Vue.use(VideoPlayer);
//注册全局通用属性,方法
import global from "@/utils/global.js";
Vue.use(global);
// 全局引入vant组件
import Vant from "vant";
import "vant/lib/index.css";

Vue.use(Vant);

// 注册按钮全局节流指令
import throttleClick from "@/utils/throttle.js";
Vue.use(throttleClick);
// 注册事件全局节流指令
import * as preventFun from "@/utils/preventFun.js";
Vue.use(preventFun);
Vue.prototype.$preventFun = preventFun;

// Flutter方法调用的Vue原型方法
Vue.prototype.$callFlutterMethod = function (methodName, params) {
    try {
        if (
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers[methodName]
        ) {
            return window.webkit.messageHandlers[methodName].postMessage(params);
        } else if (window.android && window.android[methodName]) {
            return window.android[methodName](params);
        } else {
            console.warn(`Flutter方法 ${methodName} 未找到`);
            return null;
        }
    } catch (error) {
        console.error(`调用Flutter方法 ${methodName} 时出错:`, error);
        return null;
    }
};

// 接口
import apis from "./api/config";
Vue.use(apis);

// 全局组件
import Big from "@/components/pager/Big.vue";
Vue.component("Big", Big);

// 事件总线
Vue.prototype.$bus = new Vue();

import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload);
// Vue.prototype.$PUBLIC_STATIC = "https://fdfs.cnknowledge.com/";
// console.dir(Vue);
Vue.config.productionTip = false;
Vue.filter("dayFormate", function (time) {
    //这是处理掉时间的
    let year = new Date(time).getFullYear();
    let month = new Date(time).getMonth() + 1;
    month < 10 ? (month = `0${month}`) : month;
    let day = new Date(time).getDate();
    day < 10 ? (day = `0${day}`) : day;
    // console.log(day);
    // console.log(new Date(time).getTime());
    if (isNaN(year)) {
        return "";
    }
    return `${year}-${month}-${day}`;
});

import VConsole from "vconsole";
if (process.env.NODE_ENV !== "production") {
    const vConsole = new VConsole();
    Vue.use(vConsole);
}

// 自定义storage对象，兼容iOS系统storage失效问题，H5端使用storage时需调用这个方法
// 步骤一：trycatch检测当前浏览器是否支持storage
function getStorage() {
    var storageImpl;
    try {
        localStorage.setItem("storage", "");
        localStorage.removeItem("storage");
        storageImpl = localStorage;
    } catch (err) {
        storageImpl = new LocalStorageAlternative();
    }
    return storageImpl;
}
// 步骤二： 构造函数定义 LocalStorageAlternative 类
function LocalStorageAlternative() {
    var structureLocalStorage = {};

    this.setItem = function (key, value) {
        structureLocalStorage[key] = value;
    };

    this.getItem = function (key) {
        if (typeof structureLocalStorage[key] != "undefined") {
            return structureLocalStorage[key];
        } else {
            return null;
        }
    };

    this.removeItem = function (key) {
        structureLocalStorage[key] = undefined;
    };
}
Vue.prototype.customStorage = getStorage();

// 创建一个监听本地储存的值变化方法
Vue.prototype.$addStorageEvent = function (key, data) {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent("StorageEvent");
    const storage = {
        setItem: function (k, val) {
            sessionStorage.setItem(k, val);
            // 初始化创建的事件
            newStorageEvent.initStorageEvent("setItem", false, false, k, null, val, null, null);
            // 派发对象
            window.dispatchEvent(newStorageEvent);
        },
    };
    return storage.setItem(key, data);
};

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");

// Flutter方法注册系统
function registerFlutterMethods() {
    if (!window.webkit) {
        window.webkit = { messageHandlers: {} };
    } else if (!window.webkit.messageHandlers) {
        window.webkit.messageHandlers = {};
    }

    // 定义需要注册的方法列表（您可以根据需要添加更多方法）
    const flutterMethods = ["getToken", "gubeit", "sharing", "openSearch"];

    // 动态注册方法
    flutterMethods.forEach((methodName) => {
        if (window[methodName]) {
            console.log(`注册Flutter方法: ${methodName}`);

            // 注册到android对象（兼容Android WebView）
            if (!window.android) {
                window.android = {};
            }
            window.android[methodName] = window[methodName];

            // 注册到webkit.messageHandlers（兼容iOS WKWebView）
            window.webkit.messageHandlers[methodName] = {
                postMessage: window[methodName],
            };
        }
    });
}

// 立即执行方法注册
registerFlutterMethods();

// 提供一个全局方法，用于手动注册新的Flutter方法
window.registerFlutterMethod = function (methodName, method) {
    // 将方法添加到window对象
    window[methodName] = method;

    // 注册到android对象
    if (!window.android) {
        window.android = {};
    }
    window.android[methodName] = method;

    // 注册到webkit.messageHandlers
    if (!window.webkit) {
        window.webkit = { messageHandlers: {} };
    } else if (!window.webkit.messageHandlers) {
        window.webkit.messageHandlers = {};
    }

    window.webkit.messageHandlers[methodName] = {
        postMessage: method,
    };
};
